import ExerciseOfTheDayCard from './ExerciseOfTheDayCard';

export default ExerciseOfTheDayCard;
